import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.CamionEADDto;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Nombre", cell: x => ({ data: x.Nombre }) },
    { title: "Sucursal", cell: x => ({ data: x.NombreSucursal }) },
    { title: "Peso (Ton)", cell: x => ({ data: x.Peso }) },
    { title: "Aseguradora", cell: x => ({ data: x.Aseguradora }) },
    { title: "Numero Poliza", cell: x => ({ data: x.NumeroPoliza }) },
    { title: "Permiso SCT", cell: x => ({ data: x.TipoPermiso.Clave }) },
    { title: "Numero Permiso SCT", cell: x => ({ data: x.PermisoSCT }) },
    { title: "Tipo Autotranporte", cell: x => ({ data: x.ConfigAutotransporte.Clave }) }
];

/**Obtiene las columnas del grid */
export function columnas(deps: kea.BotonesListaDeps<Entity>): Column[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [botones, ...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/camionesEAD/list/columns.tsx